/* eslint-disable max-lines */
import { BookingDocumentBillingIdType } from '@app/entities/booking-billing-documents-id';
import { BookingDocumentPaxIdType } from '@app/entities/booking-pax-documents-id';
import { BookingFormGeneralErrorTypes } from '@app/entities/booking-form-general-error';
import { FormDocumentInputTemplate } from '@forms/form-text-input/entities/input-type';
import { InputMask, InputRegex } from '@forms/form-text-input/entities/input-mask';
import { TravelBookingType } from '@pax/entities/travel-booking-types';
import { EnabledBookingDocumentsByCondition } from '@app/entities/booking-enabled-documents-by';

export const AssetBookingDocuments = {
  BOOKING_GENERAL_CONFIG: {
    DISABLED_BOOKING_BOOK_SERVICES_BY_DEV_DOCUMENT_TESTING: false,
    DISABLED_BOOKING_VALIDATE_SERVICES_BY_FILTER_DOCUMENTS: false,
  },
  BOOKING_MODULES_BUSINESS_RULES: {
    [TravelBookingType.FLIGHTS]: {
      ENABLED_PAX_MODULE_MANDATORY_PASSPORT: false,
      ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_DOCUMENTS: [
        {
          TYPE: EnabledBookingDocumentsByCondition.ENABLED_DOCUMENTS_MODULE,
          VALUES: [],
          IGNORE_RULE_AND_DISABLED_WHEN: [],
        }
      ],
      PAX_DEFAULT_DATA_BY_INTERNATIONAL_DOCUMENT_TYPE: BookingDocumentPaxIdType.PAS,
    },
    [TravelBookingType.FLIGHTS_BY_SECTOR]: {
      ENABLED_PAX_MODULE_MANDATORY_PASSPORT: false,
      ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_DOCUMENTS: [
        {
          TYPE: EnabledBookingDocumentsByCondition.ENABLED_DOCUMENTS_MODULE,
          VALUES: [],
          IGNORE_RULE_AND_DISABLED_WHEN: [],
        }
      ],
      PAX_DEFAULT_DATA_BY_INTERNATIONAL_DOCUMENT_TYPE: BookingDocumentPaxIdType.PAS,
    },
    [TravelBookingType.HOTELS]: {
      ENABLED_PAX_MODULE_MANDATORY_PASSPORT: false,
      ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_DOCUMENTS: [
        {
          TYPE: EnabledBookingDocumentsByCondition.ENABLED_DOCUMENTS_MODULE,
          VALUES: [],
          IGNORE_RULE_AND_DISABLED_WHEN: [],
        }
      ],
      PAX_DEFAULT_DATA_BY_INTERNATIONAL_DOCUMENT_TYPE: BookingDocumentPaxIdType.PAS,
    },
    [TravelBookingType.BUSES]: {
      ENABLED_PAX_MODULE_MANDATORY_PASSPORT: false,
      ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_DOCUMENTS: [
        {
          TYPE: EnabledBookingDocumentsByCondition.ENABLED_DOCUMENTS_MODULE,
          VALUES: [],
          IGNORE_RULE_AND_DISABLED_WHEN: [],
        }
      ],
      PAX_DEFAULT_DATA_BY_INTERNATIONAL_DOCUMENT_TYPE: BookingDocumentPaxIdType.PAS,
    },
    [TravelBookingType.AUTOS]: {
      ENABLED_PAX_MODULE_MANDATORY_PASSPORT: false,
      ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_DOCUMENTS: [
        {
          TYPE: EnabledBookingDocumentsByCondition.ENABLED_DOCUMENTS_MODULE,
          VALUES: [],
          IGNORE_RULE_AND_DISABLED_WHEN: [],
        }
      ],
      PAX_DEFAULT_DATA_BY_INTERNATIONAL_DOCUMENT_TYPE: BookingDocumentPaxIdType.PAS,
    },
    [TravelBookingType.PACKAGE_AIR]: {
      ENABLED_PAX_MODULE_MANDATORY_PASSPORT: false,
      ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_DOCUMENTS: [
        {
          TYPE: EnabledBookingDocumentsByCondition.ENABLED_DOCUMENTS_MODULE,
          VALUES: [],
          IGNORE_RULE_AND_DISABLED_WHEN: [],
        }
      ],
      PAX_DEFAULT_DATA_BY_INTERNATIONAL_DOCUMENT_TYPE: BookingDocumentPaxIdType.PAS,
    },
    [TravelBookingType.ACTIVITIES]: {
      ENABLED_PAX_MODULE_MANDATORY_PASSPORT: false,
      ENABLED_BILLING_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_COUNTRY_SELECTOR_ONLY_THESE_DOCUMENTS: [],
      ENABLED_PAX_MODULE_DOCUMENTS: [
        {
          TYPE: EnabledBookingDocumentsByCondition.ENABLED_DOCUMENTS_MODULE,
          VALUES: [],
          IGNORE_RULE_AND_DISABLED_WHEN: [],
        }
      ],
      PAX_DEFAULT_DATA_BY_INTERNATIONAL_DOCUMENT_TYPE: BookingDocumentPaxIdType.PAS,
    },
  },
  PAX: {
    ADULTS: [
      {
        TYPE: BookingDocumentPaxIdType.CPF,
        DOCUMENT_NAME: 'CPF',
        DOCUMENT_ID: 11,
        RAPPI_DOCUMENT_ID: 2,
        ABREVIATION: 'CPF',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.CPF,
          REGEX: InputRegex.CPF,
          FORM_INPUT: FormDocumentInputTemplate.CPF,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        },
        ERRORS: [
          {
            TYPE: BookingFormGeneralErrorTypes.MASK,
            VALUE: '*O formato esperado é: xxx.xxx.xxx-xx'
          },
          {
            TYPE: BookingFormGeneralErrorTypes.INVALID_DOCUMENT_VALUE,
            VALUE: '*O CPF é inválido'
          }
        ]
      },
      {
        TYPE: BookingDocumentPaxIdType.PAS,
        DOCUMENT_NAME: 'Passaporte',
        DOCUMENT_ID: 7,
        RAPPI_DOCUMENT_ID: 5,
        ABREVIATION: 'PAS',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.ALPHANUMERIC,
          REGEX: InputRegex.ALPHANUMERIC,
          FORM_INPUT: FormDocumentInputTemplate.ALPHANUMERIC,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        }
      },
      {
        TYPE: BookingDocumentPaxIdType.RG,
        DOCUMENT_NAME: 'RG',
        DOCUMENT_ID: 12,
        RAPPI_DOCUMENT_ID: 0,
        ABREVIATION: 'RG',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.DIGITS,
          REGEX: InputRegex.NUMERIC,
          FORM_INPUT: FormDocumentInputTemplate.DIGITS,
          IS_DISABLED: true,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        }
      },
    ],
    CHILDREN: [
      {
        TYPE: BookingDocumentPaxIdType.CPF,
        DOCUMENT_NAME: 'CPF',
        DOCUMENT_ID: 11,
        RAPPI_DOCUMENT_ID: 2,
        ABREVIATION: 'CPF',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.CPF,
          REGEX: InputRegex.CPF,
          FORM_INPUT: FormDocumentInputTemplate.CPF,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        },
        ERRORS: [
          {
            TYPE: BookingFormGeneralErrorTypes.MASK,
            VALUE: '*O formato esperado é: xxx.xxx.xxx-xx'
          },
          {
            TYPE: BookingFormGeneralErrorTypes.INVALID_DOCUMENT_VALUE,
            VALUE: '*O CPF é inválido'
          }
        ]
      },
      {
        TYPE: BookingDocumentPaxIdType.PAS,
        DOCUMENT_NAME: 'Passaporte',
        DOCUMENT_ID: 7,
        RAPPI_DOCUMENT_ID: 5,
        ABREVIATION: 'PAS',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.ALPHANUMERIC,
          REGEX: InputRegex.ALPHANUMERIC,
          FORM_INPUT: FormDocumentInputTemplate.ALPHANUMERIC,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        }
      },
      {
        TYPE: BookingDocumentPaxIdType.RG,
        DOCUMENT_NAME: 'RG',
        DOCUMENT_ID: 12,
        RAPPI_DOCUMENT_ID: 0,
        ABREVIATION: 'RG',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.DIGITS,
          REGEX: InputRegex.NUMERIC,
          FORM_INPUT: FormDocumentInputTemplate.DIGITS,
          IS_DISABLED: true,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        }
      },
    ],
    INFANTS: [
      {
        TYPE: BookingDocumentPaxIdType.CPF,
        DOCUMENT_NAME: 'CPF',
        DOCUMENT_ID: 11,
        RAPPI_DOCUMENT_ID: 2,
        ABREVIATION: 'CPF',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.CPF,
          REGEX: InputRegex.CPF,
          FORM_INPUT: FormDocumentInputTemplate.CPF,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        },
        ERRORS: [
          {
            TYPE: BookingFormGeneralErrorTypes.MASK,
            VALUE: '*O formato esperado é: xxx.xxx.xxx-xx'
          },
          {
            TYPE: BookingFormGeneralErrorTypes.INVALID_DOCUMENT_VALUE,
            VALUE: '*O CPF é inválido'
          }
        ]
      },
      {
        TYPE: BookingDocumentPaxIdType.PAS,
        DOCUMENT_NAME: 'Passaporte',
        DOCUMENT_ID: 7,
        RAPPI_DOCUMENT_ID: 5,
        ABREVIATION: 'PAS',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.ALPHANUMERIC,
          REGEX: InputRegex.ALPHANUMERIC,
          FORM_INPUT: FormDocumentInputTemplate.ALPHANUMERIC,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        }
      },
      {
        TYPE: BookingDocumentPaxIdType.RG,
        DOCUMENT_NAME: 'RG',
        DOCUMENT_ID: 12,
        RAPPI_DOCUMENT_ID: 0,
        ABREVIATION: 'RG',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.DIGITS,
          REGEX: InputRegex.NUMERIC,
          FORM_INPUT: FormDocumentInputTemplate.DIGITS,
          IS_DISABLED: true,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.HOTELS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.BUSES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.AUTOS]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
            [TravelBookingType.ACTIVITIES]: {
              NATIONAL_TRIP: true,
              INTERNATIONAL_TRIP: true,
              ONLY_NATIONAL_CITIZENS: false
            },
          },
        }
      },
    ]
  },
  BILLING: {
    NATURAL_PERSON: [
      {
        TYPE: BookingDocumentBillingIdType.PAS,
        DOCUMENT_NAME: 'Passaporte',
        DOCUMENT_ID: 7,
        RAPPI_DOCUMENT_ID: 5,
        ABREVIATION: 'PAS',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.ALPHANUMERIC,
          REGEX: InputRegex.ALPHANUMERIC,
          FORM_INPUT: FormDocumentInputTemplate.ALPHANUMERIC,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              LOCAL_NATIONALITY: false,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              LOCAL_NATIONALITY: false,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.HOTELS]: {
              LOCAL_NATIONALITY: false,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.BUSES]: {
              LOCAL_NATIONALITY: false,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.AUTOS]: {
              LOCAL_NATIONALITY: false,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.PACKAGE_AIR]: {
              LOCAL_NATIONALITY: false,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.ACTIVITIES]: {
              LOCAL_NATIONALITY: false,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
          },
        }
      },
      {
        TYPE: BookingDocumentBillingIdType.CPF,
        DOCUMENT_NAME: 'CPF',
        DOCUMENT_ID: 11,
        RAPPI_DOCUMENT_ID: 2,
        ABREVIATION: 'CPF',
        VALIDATIONS: {
          MAX_LENGTH: 15,
          MASK: InputMask.CPF,
          REGEX: InputRegex.CPF,
          FORM_INPUT: FormDocumentInputTemplate.CPF,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: false,
              FOREIGN_TRAVELER: false
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: false,
              FOREIGN_TRAVELER: false
            },
            [TravelBookingType.HOTELS]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: false,
              FOREIGN_TRAVELER: false
            },
            [TravelBookingType.BUSES]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: false,
              FOREIGN_TRAVELER: false
            },
            [TravelBookingType.AUTOS]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: false,
              FOREIGN_TRAVELER: false
            },
            [TravelBookingType.PACKAGE_AIR]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: false,
              FOREIGN_TRAVELER: false
            },
            [TravelBookingType.ACTIVITIES]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: false,
              FOREIGN_TRAVELER: false
            },
          },
        },
        ERRORS: [
          {
            TYPE: BookingFormGeneralErrorTypes.MASK,
            VALUE: '*O formato esperado é: xxx.xxx.xxx-xx'
          },
          {
            TYPE: BookingFormGeneralErrorTypes.INVALID_DOCUMENT_VALUE,
            VALUE: '*O CPF é inválido'
          }
        ]
      },
    ],
    JURIDICAL_PERSON: [
      {
        TYPE: BookingDocumentBillingIdType.CNPJ,
        DOCUMENT_NAME: 'CNPJ',
        DOCUMENT_ID: 13,
        RAPPI_DOCUMENT_ID: 1,
        ABREVIATION: 'CNPJ',
        VALIDATIONS: {
          MAX_LENGTH: 18,
          MASK: InputMask.CNPJ,
          REGEX: InputRegex.CNPJ,
          FORM_INPUT: FormDocumentInputTemplate.CNPJ,
          IS_DISABLED: false,
          DOCUMENT_BUSINESS_RULES_BY_MODULES: {
            [TravelBookingType.FLIGHTS]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.FLIGHTS_BY_SECTOR]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.HOTELS]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.BUSES]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.AUTOS]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.PACKAGE_AIR]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
            [TravelBookingType.ACTIVITIES]: {
              LOCAL_NATIONALITY: true,
              FOREIGN_NATIONALITY: true,
              FOREIGN_TRAVELER: true
            },
          },
        },
        ERRORS: [
          {
            TYPE: BookingFormGeneralErrorTypes.MASK,
            VALUE: '*O formato esperado é: xx.xxx.xxx/xxxx-xx'
          },
          {
            TYPE: BookingFormGeneralErrorTypes.INVALID_DOCUMENT_VALUE,
            VALUE: '*O CNPJ é inválido'
          }
        ]
      },
    ]
  }
};
